import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _completeStepRequest = {};
var _completeStepResponse = { onboarding: '_onboarding' };
var _deleteOnboardingRequest = {};
var _deleteOnboardingResponse = {};
var _getOrCreateOnboardingRequest = {};
var _getOrCreateOnboardingResponse = { onboarding: '_onboarding' };
var _onboarding = { steps: '_step' };
var _skipOnboardingRequest = {};
var _skipOnboardingResponse = { onboarding: '_onboarding' };
var _step = { updatedDate: 'google.protobuf.Timestamp' };
function resolveWixGroupsOnboardingV1OnboardingServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/onboarding',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/onboarding',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/onboarding',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/onboarding',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/onboarding',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/onboarding',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/onboarding',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/onboarding',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/onboarding',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/_api/onboarding',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves or starts initializing an onboarding */
export function getOrCreateOnboarding(payload) {
    var _a = serializer(_getOrCreateOnboardingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOrCreateOnboardingResponse, {
        _onboarding: _onboarding,
        _step: _step,
    }).fromJSON;
    function __getOrCreateOnboarding(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.groups.onboarding.v1.onboarding',
            method: 'POST',
            methodFqn: 'wix.groups.onboarding.v1.OnboardingService.GetOrCreateOnboarding',
            url: resolveWixGroupsOnboardingV1OnboardingServiceUrl({
                protoPath: '/v1/onboarding',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOrCreateOnboarding.fromReq = fromReq;
    __getOrCreateOnboarding.__isAmbassador = true;
    return __getOrCreateOnboarding;
}
/** Skips all ACTIVE steps in onboarding to make onboarding COMPLETED */
export function skipOnboarding(payload) {
    var _a = serializer(_skipOnboardingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_skipOnboardingResponse, {
        _onboarding: _onboarding,
        _step: _step,
    }).fromJSON;
    function __skipOnboarding(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.groups.onboarding.v1.onboarding',
            method: 'PATCH',
            methodFqn: 'wix.groups.onboarding.v1.OnboardingService.SkipOnboarding',
            url: resolveWixGroupsOnboardingV1OnboardingServiceUrl({
                protoPath: '/v1/onboarding/skip',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __skipOnboarding.fromReq = fromReq;
    __skipOnboarding.__isAmbassador = true;
    return __skipOnboarding;
}
/** Completes specific step, only for s2s calls */
export function completeStep(payload) {
    var _a = serializer(_completeStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_completeStepResponse, {
        _onboarding: _onboarding,
        _step: _step,
    }).fromJSON;
    function __completeStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.groups.onboarding.v1.onboarding',
            method: 'PATCH',
            methodFqn: 'wix.groups.onboarding.v1.OnboardingService.CompleteStep',
            url: resolveWixGroupsOnboardingV1OnboardingServiceUrl({
                protoPath: '/v1/onboarding/complete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __completeStep.fromReq = fromReq;
    __completeStep.__isAmbassador = true;
    return __completeStep;
}
/** Deletes onboarding by id */
export function deleteOnboarding(payload) {
    var _a = serializer(_deleteOnboardingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteOnboardingResponse, {}).fromJSON;
    function __deleteOnboarding(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.groups.onboarding.v1.onboarding',
            method: 'DELETE',
            methodFqn: 'wix.groups.onboarding.v1.OnboardingService.DeleteOnboarding',
            url: resolveWixGroupsOnboardingV1OnboardingServiceUrl({
                protoPath: '/v1/onboarding/delete/{onboardingId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteOnboarding.fromReq = fromReq;
    __deleteOnboarding.__isAmbassador = true;
    return __deleteOnboarding;
}
//# sourceMappingURL=http.impl.js.map